export * from './tank.module';
export * from './tank.component';
export * from './parameters/parameters.component';
export * from './display/display.component';
export * from './dailydata/dailydata.component';